import { createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'


const _hoisted_1 = { class: "\n    flex flex-row justify-between items-center border-b border-gray-lp-400 py-2 pl-6 pr-4 bg-white\n    " }
const _hoisted_2 = { class: "flex flex-row w-3/5" }
const _hoisted_3 = { class: "w-full h-full bg-gray-lp-1200 overflow-x-auto" }
const _hoisted_4 = { class: "flex flex-col h-full px-4 py-2 gap-2 overflow-y-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CargoV2EditHeaderTitle = _resolveComponent("CargoV2EditHeaderTitle")!
  const _component_CargoV2EditHeaderActions = _resolveComponent("CargoV2EditHeaderActions")!
  const _component_CargoDisputeForm = _resolveComponent("CargoDisputeForm")!
  const _component_CargoV2ManualInput = _resolveComponent("CargoV2ManualInput")!
  const _component_ScanTableSection = _resolveComponent("ScanTableSection")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("img", {
          src: _imports_0,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
          class: "w-5 mr-3 cursor-pointer",
          alt: "back"
        }),
        _createVNode(_component_CargoV2EditHeaderTitle, {
          cargoType: _ctx.form.cargoType.value,
          origin: _ctx.form.originCityCode,
          destination: _ctx.form.destinationCityCode.code
        }, null, 8, ["cargoType", "origin", "destination"])
      ]),
      _createVNode(_component_CargoV2EditHeaderActions, {
        originCityCode: _ctx.form.originCityCode,
        destinationCityCode: _ctx.form.destinationCityCode.code,
        disabledSelectSchedule: _ctx.loadingCalculate || !_ctx.isValidSearchFlight,
        disabledBooking: _ctx.loadingCalculate || !_ctx.isValidBooking,
        disabledChangeTransport: _ctx.loadingCalculate || !_ctx.isValidSelectTransport,
        showSelectSchedule: _ctx.form.cargoType.value === 'plane',
        onSelectModa: _ctx.handleSelectModa,
        onSelectSchedule: _ctx.handleSelectSchedule,
        onBooking: _ctx.handleBooking
      }, null, 8, ["originCityCode", "destinationCityCode", "disabledSelectSchedule", "disabledBooking", "disabledChangeTransport", "showSelectSchedule", "onSelectModa", "onSelectSchedule", "onBooking"])
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_CargoDisputeForm),
        _createVNode(_component_CargoV2ManualInput),
        _createVNode(_component_ScanTableSection)
      ])
    ])
  ], 64))
}